import { render, staticRenderFns } from "./obligee.vue?vue&type=template&id=0bfe10f2&scoped=true&"
import script from "./obligee.vue?vue&type=script&lang=js&"
export * from "./obligee.vue?vue&type=script&lang=js&"
import style0 from "./obligee.vue?vue&type=style&index=0&id=0bfe10f2&prod&lang=less&"
import style1 from "./obligee.vue?vue&type=style&index=1&id=0bfe10f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe10f2",
  null
  
)

export default component.exports